<template>
<div class="config-container">
  <div class="config-header">
    <div :class="['header-tab-item', item.code == current ? 'header-item-selected' : '']" v-for="(item, idx) in menus" :key="idx" @click="clickMenu(item)">{{item.name}}</div>
  </div>
  <div class="config-content">
    <template v-for="(item, idx) in menus">
      <component v-if="item.code == current" :key="idx" v-bind:is="item.com" :args="item.args"></component>
    </template>
  </div>
</div>
</template>
<script>
import AssetPowerBox from './box/Index'
import AssetPowerLine from './line/Index'
import AssetPowerPole from './pole/Index'
import AssetPowerLamp from './lamp/Index'
import AssetPowerBranch from './branch/Index'
export default {
  name: 'Home',
  components: {
    // AuthMenuItem
  },
  props: {
    sys: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      current: 's1',
      menus: [
        {code: 's1', name: '配电柜资产管理', com: AssetPowerBox, args: {}},
        {code: 's2', name: '支路资产管理', com: AssetPowerBranch, args: {}},
        {code: 's3', name: '线缆资产管理', com: AssetPowerLine, args: {}},
        {code: 's4', name: '灯杆资产管理', com: AssetPowerPole, args: {}},
        {code: 's5', name: '单灯资产管理', com: AssetPowerLamp, args: {}},
      ],
    }
  },
  watch: {
  },
  mounted: function(){
  },
  methods: {
    clickMenu: function(item){
      this.current = item.code;
    },
  }
}
</script>
<style scoped>
.config-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.config-header {
  height: 34px;
  flex: none;
  display: flex;
  margin: 0 0 15px;
}

.header-tab-item {
  border-bottom: 0;
  cursor: pointer;
  padding: 0 10px;
  line-height: 34px;
  background-color: #eef4f9;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #324252;
}
.header-tab-item:first-child {
  border-radius: 6px 0px 0px 0px;
}
.header-tab-item:last-child {
  border-radius: 0px 6px 0px 0px;
}
.header-item-selected {
  background-color: #3880fc;
  color: #ffffff;
}
.config-content {
  height: 500px;
  flex: auto;
}
</style>